<template>
  <TeamLeaderAccessCodeModal
    :isOpen="openModal"
    :close="closeModal"
    :reload="reload"
    :selectedItem="selectedItem"
    v-if="openModal"
  />
  <div class="inline-block min-width-full overflow-hidden rounded-lg shadow bg-white p-4">
    <b-row class="my-4 min-width-full align-items-center">
      <b-col md="4">
        <b-input-group>
          <b-form-input
            id="inline-form-input-name"
            class="mr-sm-2 md-4"
            placeholder="코드명 또는 코드를 입력하세요."
            v-model="search.keyword"
            v-on:keyup.enter="handleSearch"
          ></b-form-input>
          <b-input-group-append>
            <button class="btn btn-primary" v-on:click="handleSearch">검색</button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col md="8" class="text-right">
        <Button :type="BadgeTypes.purple" label="등록" :on-click="openNewModal"/>
      </b-col>
    </b-row>
    <b-table :fields="fields" :items="items" class="text-left">
      <template #cell(code)="data">
        <span class="font-monospace">{{ data.item.code }}</span>
      </template>
      <template #cell(active)="data">
        <b-badge variant="success" v-if="data.item.isActive === true">
          활성화
        </b-badge>
        <b-badge variant="danger" v-else>
          비활성화
        </b-badge>
      </template>
      <template #cell(createdAt)="data">
        {{ getDate(data.item.createdAt) }}
      </template>
      <template #cell(button)="data">
        <div class="inline-flex gap-2 justify-end items-center text-right w-full">
          <Button :type="ButtonTypes.blue" label="상세" :onClick="() => setDetail(data.item)" />
          <Button 
            v-if="data.item.isActive"
            :type="ButtonTypes.red" 
            label="비활성화" 
            :onClick="() => deactivateItem(data.item.id)" 
          />
          <Button 
            v-else
            :type="ButtonTypes.green" 
            label="활성화" 
            :onClick="() => activateItem(data.item.id)" 
          />
          <Button :type="ButtonTypes.red" label="삭제" :onClick="() => deleteItem(data.item.id)" />
        </div>
      </template>
    </b-table>
    <b-pagination
      align="center"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="pageSize"
      @page-click="changePage"
    />
  </div>
</template>
<script>
import api from "@/api/api";
import {BadgeTypes, ButtonTypes} from "@/util/enums";
import Button from "@/components/Button.vue";
import customDate from "@/util/custom-date";
import TeamLeaderAccessCodeModal from "@/components/modals/TeamLeaderAccessCodeModal.vue";

export default {
  computed: {
    ButtonTypes() {
      return ButtonTypes
    },
    BadgeTypes() {
      return BadgeTypes
    },
  },
  components: {TeamLeaderAccessCodeModal, Button},
  data() {
    return {
      currentPage: 1,
      pageSize: 30,
      totalPage: 0,
      totalRows: 0,
      openModal: false,
      fields: [
        {
          label: '코드명',
          key: 'name',
        },
        {
          label: '코드',
          key: 'code',
        },
        {
          label: '활성화 상태',
          key: 'active',
        },
        {
          label: '생성일',
          key: 'createdAt',
        },
        {
          label: '',
          key: 'button',
          thStyle: { width: "30%" },
        }
      ],
      items: [],
      search: {
        keyword: "",
      },
      selectedItem: null,
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.search.keyword = query.keyword
    }
    
    this.getPagingList(this.currentPage)
  },
  methods: {
    closeModal() {
      this.selectedItem = null
      this.openModal = false
    },
    openNewModal() {
      this.selectedItem = null
      this.openModal = true
    },
    setDetail(item) {
      this.selectedItem = item
      this.openModal = true
    },
    reload() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.keyword) {
        query.keyword = this.search.keyword
      }
      
      this.$router.replace({ query })
    },
    getDate(date) {
      return customDate.stringFormat(date)
    },
    changePage(event, page) {
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    deleteItem(id) {
      if (!confirm('정말 삭제하시겠습니까?')) return
      
      api.teamLeaderAccessCode.delete(id, (response) => {
        this.$toast.success('삭제되었습니다.', {
          position: "top-right",
          duration: 2000
        })
        this.getPagingList(this.currentPage)
      }, (err) => {
        console.log(err)
        this.$toast.error(err.response?.data?.message || '삭제에 실패했습니다.', {
          position: "top-right",
          duration: 2000
        })
      })
    },
    activateItem(id) {
      api.teamLeaderAccessCode.activate(id, (response) => {
        this.$toast.success('활성화되었습니다.', {
          position: "top-right",
          duration: 2000
        })
        this.getPagingList(this.currentPage)
      }, (err) => {
        console.log(err)
        this.$toast.error(err.response?.data?.message || '활성화에 실패했습니다.', {
          position: "top-right",
          duration: 2000
        })
      })
    },
    deactivateItem(id) {
      api.teamLeaderAccessCode.deactivate(id, (response) => {
        this.$toast.success('비활성화되었습니다.', {
          position: "top-right",
          duration: 2000
        })
        this.getPagingList(this.currentPage)
      }, (err) => {
        console.log(err)
        this.$toast.error(err.response?.data?.message || '비활성화에 실패했습니다.', {
          position: "top-right",
          duration: 2000
        })
      })
    },
    getPagingList(page) {
      let param = {
        page: page,
        keyword: this.search.keyword,
      }
      
      api.teamLeaderAccessCode.list(param, (response) => {
        const {content, totalPages, totalElements} = response.data
        this.items = content
        this.totalPage = totalPages
        this.totalRows = totalElements
        this.currentPage = page
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.text-right {
  text-align: right;
}
.font-monospace {
  font-family: monospace;
}
</style>
